import { Link, useLocation } from 'react-router-dom'
import { Home, Plus, MapPin, CalendarDays, User, Bell, MoreHorizontal } from 'lucide-react'
import { useNotificationRefresh } from '../../contexts/NotificationContext'
import { usePermissions } from '../../hooks/usePermissions'

export default function BottomNavigation() {
  const location = useLocation()
  const { contadorNoLeidas } = useNotificationRefresh()
  const { canAccessRoute } = usePermissions()
  const pathname = location.pathname

  const isPetDetail = /^\/mascotas\/[^/]+$/.test(pathname)
  const isNotifs = pathname === '/notificaciones'

  const profileLikeItem = isNotifs
    ? {
        name: 'Alertas',
        href: '/notificaciones',
        icon: Bell,
        active: true,
        badge: contadorNoLeidas > 0 ? (contadorNoLeidas > 9 ? '9+' : String(contadorNoLeidas)) : ''
      }
    : isPetDetail
      ? {
          name: 'Más',
          href: pathname,
          icon: MoreHorizontal,
          active: true,
          disabled: true
        }
      : {
          name: 'Perfil',
          href: '/perfil',
          icon: User,
          active: pathname === '/perfil' || pathname.startsWith('/perfil/')
        }

  const navigationItems = [
    { 
      name: 'Inicio',
      href: '/', 
      icon: Home,
      active: pathname === '/'
    },
    { 
      name: 'Clínicas',
      href: '/suscripciones-clinicas',
      icon: MapPin,
      active: pathname === '/suscripciones-clinicas' || pathname.startsWith('/suscripciones-clinicas/')
    },
    { 
      name: 'Cita',
      href: '/citas?nuevo=1',
      icon: Plus,
      active: pathname === '/citas' || pathname.startsWith('/citas/')
    },
    { 
      name: 'Calendario',
      href: '/citas',
      icon: CalendarDays,
      active: pathname === '/citas' || pathname.startsWith('/citas/')
    },
    profileLikeItem
  ].filter((item) => item.disabled || canAccessRoute(item.href.split('?')[0]))

  return (
    <nav className="relative z-50 w-full">
      <div className="bg-white border-t border-[#f0f0f0] pt-2 pb-3">
        <div className="flex items-end justify-around">
          {navigationItems.map((item) => {
            const isActive = item.active
            const isCenter = item.name === 'Cita'
            const isDisabled = item.disabled === true
            const Component = isDisabled ? 'button' : Link
            
            return (
              <Component
                key={item.name}
                {...(isDisabled ? { type: 'button' } : { to: item.href })}
                className={`
                  flex flex-col items-center justify-center gap-0.5 px-1 py-0.5 transition-all duration-200 flex-1
                  ${isCenter ? '-mt-3' : ''}
                `}
              >
                {isCenter ? (
                  <>
                    <span className="h-11 w-11 rounded-full bg-[#7a9a52] text-white flex items-center justify-center text-[22px] shadow-sm">
                      <item.icon className="w-6 h-6" />
                    </span>
                    <span className="text-[10px] font-medium text-[#7a9a52]">Cita</span>
                  </>
                ) : (
                  <>
                    <span className={`relative ${isActive ? 'text-[#7a9a52]' : 'text-[#aaa]'}`}>
                      <item.icon className="w-5 h-5" />
                      {item.badge ? (
                        <span className="absolute -top-1.5 -right-2 min-w-[14px] h-[14px] px-1 rounded-full bg-[#e05555] text-white text-[9px] leading-[14px] font-bold text-center">
                          {item.badge}
                        </span>
                      ) : null}
                    </span>
                    <span className={`text-[10px] ${isActive ? 'text-[#7a9a52]' : 'text-[#aaa]'}`}>
                      {item.name}
                    </span>
                  </>
                )}
              </Component>
            )
          })}
        </div>
      </div>
    </nav>
  )
}
